var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card-text",
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", "fill-height": "" } },
        [
          _c(
            "v-flex",
            [
              _vm.logs
                ? [
                    _c(
                      "v-flex",
                      [
                        _c("div", { staticClass: "pb-2 headline" }, [
                          _vm._v("Filters"),
                        ]),
                        _vm._v(" "),
                        _vm.startDateText && _vm.endDateText
                          ? _c("v-chip", { attrs: { small: "" } }, [
                              _vm._v("\n            Between  \n            "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.prettyDate(_vm.startDateText) ||
                                      _vm.moment("MMMM Do YYYY")
                                  )
                                ),
                              ]),
                              _vm._v(
                                "\n             \n            —\n             \n            "
                              ),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.prettyDate(_vm.endDateText) ||
                                      _vm.moment("MMMM Do YYYY")
                                  )
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.searchTermText
                          ? _c("v-chip", { attrs: { small: "" } }, [
                              _vm._v("Search logs:  "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.searchTermText)),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.tenantText
                          ? _c("v-chip", { attrs: { small: "" } }, [
                              _vm._v("Tenant  "),
                              _c("strong", [_vm._v(_vm._s(_vm.tenantText))]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showLogsIfHasErrorText
                          ? _c("v-chip", { attrs: { small: "" } }, [
                              _vm._v(_vm._s(_vm.showLogsIfHasErrorText)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showLogsIfNotTestRunText
                          ? _c("v-chip", { attrs: { small: "" } }, [
                              _vm._v(_vm._s(_vm.showLogsIfNotTestRunText)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showLogsIfNotSniffText
                          ? _c("v-chip", { attrs: { small: "" } }, [
                              _vm._v(_vm._s(_vm.showLogsIfNotSniffText)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.executionIdText
                          ? _c("v-chip", { attrs: { small: "" } }, [
                              _vm._v("With execution id:  "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.executionIdText)),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isRollback
                          ? _c("v-chip", { attrs: { small: "" } }, [
                              _vm._v(_vm._s(_vm.showRollbackLogsText)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "headline mt-3" }, [
                          _vm._v("Logs"),
                        ]),
                        _vm._v(" "),
                        _vm.logs.length > 0
                          ? _c(
                              "div",
                              { staticClass: "my-3" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticStyle: { "line-height": "19px" },
                                    attrs: { color: "info" },
                                  },
                                  [_vm._v("error_outline")]
                                ),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.logs.length) +
                                      " " +
                                      _vm._s(
                                        _vm.pluralize("log", _vm.logs.length)
                                      )
                                  ),
                                ]),
                                _vm._v(" found.\n            "),
                                _c("br"),
                                _vm._v("Logs are grouped by their "),
                                _c("b", [_vm._v("process id")]),
                                _vm._v(" and then sorted by "),
                                _c("b", [_vm._v("date")]),
                                _vm._v(".\n          "),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              { staticClass: "my-3" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-1",
                                    staticStyle: { "line-height": "19px" },
                                    attrs: { color: "error" },
                                  },
                                  [_vm._v("error_outline")]
                                ),
                                _vm._v(
                                  "\n            No results found\n          "
                                ),
                              ],
                              1
                            ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("LogsGroupByProcessId", { attrs: { logs: _vm.logs } }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }